import { sortBy, useOnMount } from '@seiue/util'
import { Tree } from 'antd'
import { FC, useContext } from 'react'

import { CourseContext } from '../../context'
import { TreeOutline } from '../../types'

import { TreeNode } from './TreeNode'
import { CourseOutlineTaskTypeEnum } from 'packages/sdks-next/growp'

/**
 * 大纲
 *
 * @param param0 - 参数
 * @param param0.outlines - 大纲
 * @returns 大纲
 */
export const Outline: FC<{
  outlines: TreeOutline[]
}> = ({ outlines }) => {
  const { currentOutline, setCurrentOutline, isPreview, completedDetails } =
    useContext(CourseContext)

  const orderOutlines = sortBy(outlines, 'weight')

  useOnMount(() => {
    setCurrentOutline?.(orderOutlines?.[0]?.children?.[0])
  })

  const defaultExpandedKeys = orderOutlines.map((o) => o.key)

  return (
    <Tree
      autoExpandParent={false}
      defaultExpandedKeys={defaultExpandedKeys}
      treeData={orderOutlines}
      titleRender={(props) => {
        const { children, parentId, type, title, key } = props
        const isSelectedChildren = !!props?.children?.find(
          (child) => child.key === currentOutline?.key
        )

        const isFinished = !!completedDetails?.find(
          (detail) => detail.outlineTaskId === Number(props?.key)
        )?.isCompleted

        const childKeys = props.outlineTaskIds
        const childCompleteDetails = completedDetails?.filter((detail) => {
          return childKeys?.includes(detail.outlineTaskId || 0)
        })
        const completedCount =
          childCompleteDetails?.filter((detail) => detail.isCompleted).length ||
          0

        const percent =
          children?.length && childCompleteDetails?.length
            ? (completedCount / children?.length) * 100
            : undefined

        return (
          <TreeNode
            isSelected={currentOutline?.key === key}
            onClick={() => {
              if (props?.parentId === 0) {
                return
              }
              const ele = document.getElementById('test-paper-save')
              if (
                currentOutline?.type &&
                currentOutline?.type === CourseOutlineTaskTypeEnum.Exercise &&
                ele
              ) {
                ele.click()
              }
              setCurrentOutline?.(props)
            }}
            name={title}
            type={type}
            isParent={parentId === 0}
            isSelectedChildren={isSelectedChildren}
            isPreview={isPreview}
            isFinished={isFinished}
            percent={percent}
          />
        )
      }}
    />
  )
}
